import React from 'react';

export const SourceTypeLong = (props: { size: number } = { size: 24 }) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="new-Icon/source_long"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect
        id="bck-SorceDataType"
        fill="#575757"
        x="0"
        y="0"
        width="32"
        height="32"
        rx="2"
      ></rect>
      <g
        id="LNG"
        transform="translate(3.500000, 8.000000)"
        fill="#FFFFFF"
        fill-rule="nonzero"
      >
        <polygon
          id="Path"
          points="0 15.6086957 0 0.130434783 2.2173913 0.130434783 2.2173913 13.3913043 6.60869565 13.3913043 6.60869565 15.6086957"
        ></polygon>
        <polygon
          id="Path"
          points="7.95652174 15.6086957 7.95652174 0.130434783 10.0869565 0.130434783 13.4347826 9.45652174 13.4782609 9.45652174 13.4782609 0.130434783 15.6956522 0.130434783 15.6956522 15.6086957 13.6086957 15.6086957 10.2173913 6.30434783 10.173913 6.30434783 10.173913 15.6086957"
        ></polygon>
        <path
          d="M17.5652174,3.7826087 C17.5652174,3.15942029 17.673913,2.60869565 17.8913043,2.13043478 C18.1086957,1.65217391 18.3985507,1.25362319 18.7608696,0.934782609 C19.1086957,0.630434783 19.5036232,0.398550725 19.9456522,0.239130435 C20.3876812,0.0797101449 20.8333333,0 21.2826087,0 C21.7318841,0 22.1775362,0.0797101449 22.6195652,0.239130435 C23.0615942,0.398550725 23.4637681,0.630434783 23.826087,0.934782609 C24.173913,1.25362319 24.4565217,1.65217391 24.673913,2.13043478 C24.8913043,2.60869565 25,3.15942029 25,3.7826087 L25,4.56521739 L22.7826087,4.56521739 L22.7826087,3.7826087 C22.7826087,3.24637681 22.634058,2.85144928 22.3369565,2.59782609 C22.0398551,2.3442029 21.6884058,2.2173913 21.2826087,2.2173913 C20.8768116,2.2173913 20.5253623,2.3442029 20.2282609,2.59782609 C19.9311594,2.85144928 19.7826087,3.24637681 19.7826087,3.7826087 L19.7826087,11.9565217 C19.7826087,12.4927536 19.9311594,12.8876812 20.2282609,13.1413043 C20.5253623,13.3949275 20.8768116,13.5217391 21.2826087,13.5217391 C21.6884058,13.5217391 22.0398551,13.3949275 22.3369565,13.1413043 C22.634058,12.8876812 22.7826087,12.4927536 22.7826087,11.9565217 L22.7826087,9.04347826 L21.0217391,9.04347826 L21.0217391,7.08695652 L25,7.08695652 L25,11.9565217 C25,12.6086957 24.8913043,13.1666667 24.673913,13.6304348 C24.4565217,14.0942029 24.173913,14.4782609 23.826087,14.7826087 C23.4637681,15.1014493 23.0615942,15.3405797 22.6195652,15.5 C22.1775362,15.6594203 21.7318841,15.7391304 21.2826087,15.7391304 C20.8333333,15.7391304 20.3876812,15.6594203 19.9456522,15.5 C19.5036232,15.3405797 19.1086957,15.1014493 18.7608696,14.7826087 C18.3985507,14.4782609 18.1086957,14.0942029 17.8913043,13.6304348 C17.673913,13.1666667 17.5652174,12.6086957 17.5652174,11.9565217 L17.5652174,3.7826087 Z"
          id="Path"
        ></path>
      </g>
    </g>
  </svg>
);
